import type { ReactNode } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface ScheduleDateNavigationProps {
  label: ReactNode;
  onPrevious: () => void;
  onNext: () => void;
  canGoBack?: boolean;
  canGoNext?: boolean;
  previousLabel?: string;
  nextLabel?: string;
  indicator?: ReactNode;
  extra?: ReactNode;
}

export function ScheduleDateNavigation({ label, onPrevious, onNext, canGoBack = true, canGoNext = true, previousLabel, nextLabel, indicator, extra }: ScheduleDateNavigationProps) {
  const { t } = useTranslation("common");
  return (
    <div className="schedule-date-navigation flex w-full items-center gap-2">
      <Button type="button" variant="outline" size="icon" disabled={!canGoBack} onClick={onPrevious} title={previousLabel} aria-label={previousLabel ?? t("previous", { defaultValue: "Précédent" })}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <div className="flex min-h-10 min-w-0 flex-1 items-center justify-center gap-2 rounded-md border border-border bg-card px-2 text-center text-xs font-semibold text-card-foreground sm:text-sm">
        <span className="min-w-0">{label}</span>{indicator}
      </div>
      <Button type="button" variant="outline" size="icon" disabled={!canGoNext} onClick={onNext} title={nextLabel} aria-label={nextLabel ?? t("next", { defaultValue: "Suivant" })}>
        <ChevronRight className="h-4 w-4" />
      </Button>
      {extra}
    </div>
  );
}